<template>
  <div class="layout-content">
    <div class="zz-loading-mask" v-show="loading">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle
            class="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="2"
            stroke-miterlimit="10"
          ></circle>
        </svg>
      </div>
      <div class="close-loading-btn">
        <i @click="closeLoading" class="el-icon-close"></i>
      </div>
    </div>
    <!-- 全局资源的loadding -->
    <div class="zz-loading-mask" v-show="loading2">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle
            class="path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke-width="2"
            stroke-miterlimit="10"
          ></circle>
        </svg>
      </div>
      <div class="close-loading-btn">
        <i @click="$store.state.loadding2 = false" class="el-icon-close"></i>
      </div>
    </div>

    <div class="content" id="contentRight">
      <!--全屏时不显示头部-->
      <div
        class="header"
        id="__sys_page_header__"
        v-if="!$route.meta.fullscreen"
      >
        <!--海舒提议：侧边栏没有时在头部显示logo-->
        <header-component
          :showLogo="secondRouters && secondRouters.length == 0"
        ></header-component>
      </div>
      <div class="frame-wrapper" id="frame-wrapper" style="padding: 0px">
        <!--全屏时和没有菜单时不显示侧边导航-->
        <div
          class="nav"
          id="navLeft"
          v-x-scroll="{
            left: 'navLeft',
            right: 'contentRight',
            max: 280,
            min: 182,
          }"
          v-if="
            !$route.meta.fullscreen && secondRouters && secondRouters.length > 0
          "
        >
          <nav-component @changeCollapse="changeCollapse"></nav-component>
        </div>

        <!--主应用渲染区，用于挂载主应用路由触发的组件，使用$route.name来判断是不是主应用组件-->
        <router-view v-show="$route.name"></router-view>
        <div class="right-content">
          <!-- 展示监测因素菜单的路由头 -->
          <factorInfo v-if="$route.path.includes('factorInfo')" />
          <!--子应用渲染区，用户挂载子应用节点-->
          <div
            v-show="!$route.name"
            id="frame"
            style="padding: 0px"
            :style="getClientHeight()"
          ></div>
        </div>
      </div>
    </div>
    <floatDialog
      :ref="item.id"
      v-floatDrag
      :key="item.id"
      :width="item.width"
      :height="item.height"
      :data="item"
      v-for="item in floatList"
      v-show="!item.miniSize"
      @minus="minusFloadDialog(item.id)"
      @close="closeFloatDialog(item.id)"
    >
      <span slot="title">{{ item.title }}</span>
      <component :is="item.name" :config="item.config"></component>
    </floatDialog>
    <div class="mini-float-wrapper">
      <miniFloatDialog
        :key="item.id + 'mini'"
        v-for="item in floatList"
        v-show="item.miniSize"
        @maxim="maximFloadDialog(item.id)"
        @close="closeFloatDialog(item.id)"
      >
        <span slot="title">{{ item.title }}</span>
      </miniFloatDialog>
    </div>
  </div>
</template>

<script>
import startQiankun from "@/micro";
//import navData from "@/data/nav.js"
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import { getSystemRole } from "@/utils/auth.js";
import {
  cancel,
  changeFavicon,
  imgBaseUrl,
  getDomainPrefix,
} from "@/utils/common.js";
import { getToken } from "@/utils/auth.js";

export default {
  data() {
    return {
      navData: [],
      config: {},
      showOrigin: false,
      noskinRequired: ["maintenance"],
    };
  },
  computed: {
    ...mapGetters([
      "secondRouters",
      "floatList",
      "pageConfig",
      "projectInfo",
      "userInfo",
    ]),
    loading() {
      return this.$store.state.loadding;
    },
    loading2() {
      return this.$store.state.loadding2;
    },
  },
  components: {
    headerComponent: () => import("@/layout/header.vue"),
    floatDialog: () => import("@/components/floatDialog"),
    miniFloatDialog: () => import("@/components/miniFloatDialog"),
    //navComponent:() => import("@/layout/nav.vue")
    navComponent: () => import("@/layout/Sidebar/index.vue"),
    factorInfo: () => import("@/views/factorInfo/index.vue"),
  },
  mounted() {
    startQiankun();
    this.getPageConfig();
    this.getUserInfo();
    this.getDomainList();
  },
  watch: {
    pageConfig(newVal) {
      if (newVal) {
        this.config = {
          platformName: newVal.platformName,
          universalAddress: newVal.universalAddress,
          docUrl: newVal.docUrl,
          screenAnimation: newVal.screenAnimation,
          showFontSwitch: newVal.showFontSwitch,
          logoTypeDeep: newVal.logoTypeDeep || "/image/logo_dark.png",
          logoTypeLight: newVal.logoTypeLight || "/image/logo.png",
          websiteLogoPath: newVal.websiteLogoPath,
        };
        document.title = this.config.platformName;
        changeFavicon(this.getRealUrl(this.config.websiteLogoPath));
      }
    },
  },
  methods: {
    getClientHeight() {
      if (this.$route.path.includes("factorInfo")) {
        return "height:calc(100% - 50px)";
      } else {
        return "height:100%";
      }
    },
    changeCollapse(flag) {
      let el = document.getElementById("navLeft");
      if (flag) {
        el.style.width = "80px";
      } else {
        el.style.width = "200px";
      }
    },
    getRealUrl(url) {
      let str = "/image/";
      if (url.indexOf(str) == 0) {
        return url;
      } else {
        return imgBaseUrl + url;
      }
      return item;
    },
    getPageConfig() {
      let domain = window.location.pathname;
      let domainPrefix = getDomainPrefix(domain) || "origin";
      this.$httpSys
        .get(
          "/crm/customizeInfo/pass/findByDomainPrefixAndStyle?domainPrefix=" +
            domainPrefix +
            "&loginStyle=0"
        )
        .then((res) => {
          if (res.data) {
            this.$store.commit("SET_PAGECONFIG", res.data);
          } else {
            this.config = {
              platformName: this.$t("藤州浔江大桥健康监测系统"),
              universalAddress: "",
              docUrl: "",
              screenAnimation: 1,
              showFontSwitch: 1,
              logoTypeDeep: "/image/logo_dark.png",
              logoTypeLight: "/image/logo.png",
              websiteLogoPath: "",
            };
            document.title = this.$t("藤州浔江大桥健康监测系统");
            this.$store.commit("SET_PAGECONFIG", this.config);
          }
        })
        .catch(() => {
          this.config = {
            platformName: this.$t("藤州浔江大桥健康监测系统"),
            universalAddress: "",
            docUrl: "",
            screenAnimation: 1,
            showFontSwitch: 1,
            logoTypeDeep: "/image/logo_dark.png",
            logoTypeLight: "/image/logo.png",
            websiteLogoPath: "",
          };
          document.title = this.$t("藤州浔江大桥健康监测系统");
          this.$store.commit("SET_PAGECONFIG", this.config);
        });
    },
    getUserInfo() {
      if (this.userInfo && this.userInfo.id) {
        this.$httpSys.get("auth/user/" + this.userInfo.id).then((data) => {
          // let userInfo = this.userInfo;
          // userInfo.name = data.data.name;
          let userInfo = data.data;
          this.$store.commit("SET_USERINFO", userInfo);
        });
      }
    },
    getDomainList() {
      if (getToken()) {
        this.$httpSys.get("/auth/user/findUserInfo").then((res) => {
          let obj = res.data;
          //保存企业列表
          if (obj.systemRole) {
            // 查询列表
            let sendObj = {
              pageObj: {
                current: 1,
                size: 1000,
              },
            };
            this.$httpSys
              .post("/crm/customizeInfo/page", sendObj)
              .then((res) => {
                const domainList = res.data.list
                  .map((item) => {
                    return {
                      domainPrefix: item.domainPrefix,
                      customName: item.customName,
                    };
                  })
                  .filter((item) => item.domainPrefix !== "origin");
                domainList.unshift({
                  domainPrefix: "",
                  customName: this.$t("默认"),
                });
                this.$store.commit("SET_DOMAINLIST", domainList);
              });
          } else {
            // 直接获取
            const domainList = obj.pageCustomize.map((item) => {
              return {
                domainPrefix: item.domainPrefix,
                customName: item.customName,
              };
            });
            if (obj.www) {
              domainList.unshift({
                domainPrefix: "",
                customName: this.$t("默认"),
              });
            }
            this.$store.commit("SET_DOMAINLIST", domainList);
          }
        });
      }
    },
    closeLoading() {
      cancel();
    },
    closeFloatDialog(id) {
      this.deleteFloatList(id);
    },
    minusFloadDialog(id) {
      this.minusFloadList(id);
    },
    maximFloadDialog(id) {
      this.maximFloadList(id);
      this.$refs[id][0].setZIndex();
    },
    ...mapMutations([
      "deleteFloatList",
      "clearFloatList",
      "minusFloadList",
      "maximFloadList",
    ]),
  },
};
</script>
<style lang="scss">
.right-content {
  flex: 1;
  min-width: 0px;
}
#frame > div {
  height: 100%;
}
.nav {
  height: 100%;
  margin-top: 3px;
  width: auto !important;
  .el-menu {
    // width: 182px;
    width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.layout-content {
  width: 100%;
  height: 100%;
  display: flex;
  .mini-float-wrapper {
    position: fixed;
    bottom: 0;
    right: 0;
    height: auto;
    width: auto;
    z-index: 9999;
  }
  .content {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .header {
      width: 100%;
      height: 55px;
    }
    .frame-wrapper {
      flex: 1;
      box-sizing: border-box;
      //overflow: auto;
      height: 100%;
      position: relative;
      display: flex;
      overflow: hidden;
      #frame {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
      }
    }
  }
  $green: #008744;
  $blue: #0057e7;
  $red: #d62d20;
  $yellow: #ffa700;
  $white: #eee;
  .close-loading-btn {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 4000;
    color: #fff;
    background: #929292;
    i {
      width: 30px;
      height: 30px;
      font-size: 30px;
      cursor: pointer;
    }
  }
  .zz-loading-mask {
    position: absolute;
    z-index: 4000;
    width: 100px;
    height: 100px;
    margin-top: -50px;
    margin-left: -50px;
    top: 50%;
    bottom: 0;
    left: 50%;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    .loader {
      position: absolute;
      top: 50%;
      left: 40%;
      margin-left: 10%;
      width: 60px;
      transform: translate3d(-50%, -50%, 0);
      &:before {
        content: "";
        display: block;
        padding-top: 100%;
      }

      .circular {
        animation: rotate 2s linear infinite;
        height: 100%;
        transform-origin: center center;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }

      .path {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
        animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
        stroke-linecap: round;
      }

      @keyframes rotate {
        100% {
          transform: rotate(360deg);
        }
      }

      @keyframes dash {
        0% {
          stroke-dasharray: 1, 400;
          stroke-dashoffset: 0;
        }
        50% {
          stroke-dasharray: 89, 400;
          stroke-dashoffset: -35px;
        }
        100% {
          stroke-dasharray: 89, 400;
          stroke-dashoffset: -124px;
        }
      }

      @keyframes color {
        100%,
        0% {
          stroke: $red;
        }
        40% {
          stroke: $blue;
        }
        66% {
          stroke: $green;
        }
        80%,
        90% {
          stroke: $yellow;
        }
      }
    }
  }
}
</style>
